import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataSource } from '../_models/DataSource';
import { ViewSource } from '../_models/ViewSource';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {

  private apiKeySource = new BehaviorSubject<string>("");
  currentApiKey = this.apiKeySource.asObservable();

  private dataSource = new BehaviorSubject<DataSource>(null);
  currentDataSource = this.dataSource.asObservable();

  private viewSource = new BehaviorSubject<ViewSource>(null);
  currentViewSource = this.viewSource.asObservable();

  constructor() { }

  notifyCurrentApiKey(apiKey: string) {
    this.apiKeySource.next(apiKey);
  }

  notifyCurrentDataSource(data: DataSource) {
    this.dataSource.next(data);
  }

  notifyCurrentView(view: ViewSource) {
    this.viewSource.next(view);
  }

}
